import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_uxq2uydaxj: FaireBrandEntity = {
  token: "b_uxq2uydaxj",
  type: "brand",
  name: "One and Only Collective",
  avatarUrl:
    "https://cdn.faire.com/fastly/c9f3de42957ee1a088dd15553afc337c7f484e7baf8d1bc010bd4b77685e3d0d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/aa420179891223126b540948efdb05249448129c144965299afb72e4360e3a76.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c9f3de42957ee1a088dd15553afc337c7f484e7baf8d1bc010bd4b77685e3d0d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/aa420179891223126b540948efdb05249448129c144965299afb72e4360e3a76.png",
  location: "90015, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 126,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to One and Only Collective, where fashion meets passion!\n\nBorn in 2015, we’re a wholesale fashion manufacturer that’s all about bringing the latest trends to life. Our talented team of designers, based in sunny Australia, creates fresh and fashion-forward pieces that are distributed to retailers and agencies around the globe.\n\nWhat sets us apart? It's all in the details! From intricate designs to carefully selected fabrics, we pride ourselves on quality and innovation. We go above and beyond to provide exceptional service, ensuring that every step of your experience with us is smooth, stylish, and unforgettable.\n\nWe're a dynamic crew spread across Los Angeles, CA and Australia, always working hand-in-hand to stay ahead of trends and meet the unique needs of our clients. With our extensive network and industry know-how, we’re not just keeping up with the fashion world – we’re shaping it.\n\nWhether it’s design, manufacturing, or wholesale logistics, we’ve got the skills and expertise to deliver exceptional results, from concept to delivery. At One and Only Collective, we make fashion happen – just for you!",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:50.738Z",
    importedBy: "entity-db-cli",
  },
};
